import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import {
  VictoryChart,
  VictoryScatter,
  VictoryTooltip,
  VictoryAxis,
} from 'victory';

import Select from 'react-select';

import { setSelectedFeatureScoreType } from '../../../actions/DeepSEAActions';
import { focusGlowStyle } from '../../ui/sharedStyles';

import { FeatureTheme } from '../VictoryThemes/GenomeThemes';

class FeatureScatterPlot extends Component {
  static propTypes = {
    selectedVariant: PropTypes.shape({
      position: PropTypes.number,
      chromosome: PropTypes.string,
      ref_allele: PropTypes.string,
      alt_allele: PropTypes.string,
    }).isRequired,
    featureScores: PropTypes.arrayOf(PropTypes.object).isRequired,
    color: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedFeatureScoreType: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
      label: PropTypes.string,
      range: PropTypes.arrayOf(PropTypes.number),
      reverse_order: PropTypes.bool,
    }).isRequired,
    title: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    const { featureScores } = this.props;
    return nextProps.featureScores !== featureScores;
  }

  renderTooltip = data =>
    data.feature.cell_type.name !== 'None'
      ? `${data.feature.cell_type.name.replace(/_/g, ' ')} / ${
          data.feature.chromatin_feature_type.name
        }
    Score: ${data.y.toFixed(2)}`
      : `${data.feature.chromatin_feature_type.name}
    Score: ${data.y.toFixed(2)}`;

  render() {
    const {
      featureScores,
      options,
      selectedFeatureScoreType,
      selectedVariant,
      color,
      title,
      dispatch,
    } = this.props;

    const defaultYaxis =
      selectedFeatureScoreType.range.length > 2
        ? [selectedFeatureScoreType.range[0], selectedFeatureScoreType.range[2]]
        : selectedFeatureScoreType.range;
    const minimumY = defaultYaxis[0];
    const maximumY = defaultYaxis[1];
    const domain = featureScores.length
      ? [
          Math.min(featureScores[0].y, minimumY),
          Math.max(featureScores[featureScores.length - 1].y, maximumY),
        ]
      : null;
    return (
      <div>
        {selectedVariant ? (
          <h4>
            {`${title} for ${selectedVariant.chromosome}:${selectedVariant.position} `}
            {selectedVariant.ref_allele && selectedVariant.ref_allele}
            {selectedVariant.alt_allele && '>'}
            {selectedVariant.alt_allele && selectedVariant.alt_allele}
          </h4>
        ) : (
          <h4>{title}</h4>
        )}
        <div style={{ width: 200, float: 'left', marginBottom: 20 }}>
          <Select
            isSearchable={false}
            defaultValue={options[0]}
            options={options}
            value={selectedFeatureScoreType}
            onChange={selectedOption => {
              dispatch(setSelectedFeatureScoreType(selectedOption));
            }}
            styles={focusGlowStyle}
          />
        </div>
        <VictoryChart theme={FeatureTheme} domain={domain && { y: domain }}>
          <VictoryAxis label="Rank" fixLabelOverlap />
          <VictoryAxis
            label={selectedFeatureScoreType.label}
            dependentAxis
            fixLabelOverlap
          />
          <VictoryScatter
            labelComponent={<VictoryTooltip {...FeatureTheme.tooltip} />}
            labels={d => this.renderTooltip(d.datum)}
            data={featureScores}
            style={{
              data: {
                fill: d => color(d.datum.y),
                strokeWidth: '1px',
                stroke: '#999999',
              },
            }}
          />
        </VictoryChart>
      </div>
    );
  }
}

function select(state) {
  return {
    selectedVariant: state.genome.selectedVariant,
    selectedFeatureScoreType: state.deepsea.selectedFeatureScoreType,
  };
}
export default connect(select)(FeatureScatterPlot);
